import store from '@/shared/store'
import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import i18n from '@hw-core/libs/i18n'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'

export default function useRequestList() {
  // Use toast
  const toast = useToast()
  // Table Handlers
  const tableColumns = [
    { key: 'createdAt', label: i18n.t('created_at') },
    { key: 'name', label: i18n.t('name') },
    { key: 'type', label: i18n.t('type') },
    { key: 'processer', label: i18n.t('creator') },
    { key: 'ticketId', label: i18n.t('ticket') },
  ]
  const statusOptions = [
    { label: i18n.t('active'), value: 'active' },
    { label: i18n.t('closed'), value: 'closed' },
  ]

  const refRequestListTable = ref(null)
  const currentPage = ref(1)
  const perPage = ref(10)
  const statusFilter = ref({ label: i18n.t('active'), value: 'active' })
  const loadMore = ref(true)
  const canLoadMore = ref(false)
  const selectedAccount = computed(() => store.state.appAccount.selectedAccount)
  let requests = []

  const refetchData = () => {
    refRequestListTable.value.refresh()
  }

  watch([currentPage, statusFilter], (newVal, oldVal) => {
    if (newVal[0] === oldVal[0]) {
      requests = []
    }
    refetchData()
  })

  const fetchRequests = (ctx, callback) => {
    const accountId = selectedAccount.value.value.id
    store
      .dispatch('appRequest/fetchRequests', {
        perPage: perPage.value,
        status: statusFilter.value.value,
        list: requests,
        accountId,
      })
      .then(({ data, isMore }) => {
        requests = data
        canLoadMore.value = isMore
        loadMore.value = false

        callback(requests)
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching request list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const onLoadMore = () => {
    currentPage.value += 1
    loadMore.value = true
  }

  return {
    refRequestListTable,
    tableColumns,
    statusFilter,
    statusOptions,
    perPage,
    loadMore,
    canLoadMore,

    onLoadMore,
    fetchRequests,
  }
}
